import { useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { deleteTopic } from '../../../../lib/redux/actions.jsx';
import DeleteComponent from '../../../../shared/SettingsModal/DeleteComponent.jsx';
import { Modal } from '../Modals/Modal.jsx';

export const DeleteModal = ({ open, setOpen, item, setItem }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { t } = useTranslation('edit');
  const deletePhrases = [
    t('edit:topicsList:deleteTopicPhrase1'),
    t('edit:topicsList:deleteTopicPhrase2'),
  ];

  const onClose = () => {
    setOpen(false);
    setItem(null);
  };

  const onConfirm = () => {
    dispatch(deleteTopic(item)).then(() => {
      queryClient.invalidateQueries(['boardSettings']);
      onClose();
    });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <DeleteComponent
        phrases={deletePhrases}
        onConfirm={onConfirm}
        onCancel={onClose}
      />
    </Modal>
  );
};
